<template>
    <div class="m-0">
        <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
            <CCard class="bg-white b-20 m-" style="border:none;">
                <CRow>
                    <CCol sm="12">
                        <h3 class="custom-40px-700 text-center mt-3">ASK AI</h3>
                        <p class="text-center m-2 font-inter font-color-696969 custom-24px-400">How can we help you?</p>
                    </CCol>
                    <CContainer class="mt-5">
                        <CCol sm="12">
    
                            <CCard class="custom-bg-purple-light">
                                <CRow class="p-3">
                                    <CCol sm="1">
                                        <img src="../assets/img/Avatar1.png" style="max-width:20px" />
                                    </CCol>
                                    <CCol sm="11">
                                        <label class="custom-16px-500 text-left font-color-928AFD m-0">
                                           {{ Statement }}
                                        </label>
                                    </CCol>
                                </CRow>
                            </CCard>
    
                            <div>
                                <CRow>
                                    <CCol sm="1"> <img src="../assets/img/logoresult.png" style="max-width:40px" /></CCol>
                                    <CCol sm="11">
                                        <label class="custom-18px-600 text-left mt-2">Result</label>
                                    </CCol>
                                </CRow>
                            </div>
                            <div v-if="this.Error == true" class="ml-4 mr-4 mt-4">
                                <CAlert show color="danger">
                                    <strong class="text-danger mr-2">Error !</strong> {{ Message }}
                                </CAlert>
                            </div>
                            <CCard class="bg-grey-card mt-3" style="min-height:100px">
                                <span class="text-center font-color-171717 mt-5">{{ lblProgress }}</span>
                                <!-- <tbody v-for="(item, index) in result" :key="index" class="p-2">
                                                <tr v-for="(value, key) in item" :key="key" class="font-color-171717 custom-18px-600">
                                                    <td>{{ key }}: </td>
                                                    <td>{{ value }}</td>
                                                </tr>
                                            </tbody>
                 -->
                 <div style="max-height: 300px; overflow-y: auto; overflow-x: auto; scrollbar-width: none; -ms-overflow-style: none;">
                 <table class="table table-responsive-sm" v-if="result && result.length > 0">
  <thead>
    <tr>
      <th v-for="(key, index) in Object.keys(result[0])" :key="index">
        {{ key }}
      </th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="(item, index) in result" :key="index">
      <td v-for="(value, key) in item" :key="key">
        <span style="display:none">{{ key }}: </span>{{ value }}
      </td>
    </tr>
  </tbody>
</table>
</div>
    
    
    
                            </CCard>
    
                            <CCard class="bg-grey-card mt-3" style="min-height:100px" v-if="showAnswer === true">
    <span class="text-center font-color-171717 mt-5">{{ lblProgressAns }}</span>
    <div style="max-height: 300px; overflow-y: auto; overflow-x: auto; scrollbar-width: none; -ms-overflow-style: none;">
        <table class="table table-responsive-sm" v-if="answerAsk && answerAsk.length > 0">
            <thead>
                <tr>
                    <th v-for="(key, index) in Object.keys(answerAsk[0])" :key="index">
                        {{ key }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in answerAsk" :key="index">
                    <td v-for="(value, key) in item" :key="key">
                        <span style="display:none">{{ key }}:</span>{{ value }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</CCard>


                            <CCard class="bg-grey-card">
                                <CRow class="p-3">
                                    <CCol sm="1" class="mt-2">
                                        <img src="../assets/img/Magic Stick 3.png" style="max-width:20px" />
                                    </CCol>
                                    <CCol sm="9">
                                        <input type="text" placeholder="Please write your request here.." class="transparent-input" style="width:100%" v-model="askStatement" />
                                    </CCol>
                                    <CCol sm="2">
                                        <div class="text-right">
                                            <CButton type="button" class="custom-border-purple text-white" @click="SubmitAsk()">Send</CButton>
                                        </div>
                                    </CCol>
                                </CRow>
                            </CCard>
    
    
                        </CCol>
                    </CContainer>
    
                </CRow>
            </CCard>
    
        </CCol>
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import ToggleCard from '../components/Toggle.vue';

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        MainlayoutLogin,
        Footerlayout,
        ToggleCard
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrNoArrow,
            result: [],
            Statement: this.$route.query.statement,
            lblProgress: "",
            lblProgressAns: "",
            showAnswer: false,
            answerAsk: [],
            askStatement: "",
            dynamicFields: [],
            Error: false

        };
    },
    created() {
        AOS.init();
    },
    async mounted() {

        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser();
                this.GetAnswerAI();
            } else {
                this.GoToLogin();
            }
        } catch (error) {
            this.GoToLogin();
            console.error("Error during authentication:", error);
            // Handle the error here
        }
    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        // async GetAnswerAI() {
        //     try {
        //         this.lblProgress = 'Processing';
        //         const response = await this.$API.get(this.$AskAI + "?statement=" + this.$route.query.statement, {
        //             withCredentials: true,
        //         });
        //         if (response.status === 200) {
        //             this.result = response.data;
        //             this.lblProgress = '';

        //             const rawData = response.data;

        //             // Remove the header row and map the data to new array
        //             this.result = rawData.slice(1).map(user => ({
        //             full_name: user[2],
        //             email: user[1]
        //             }));
        //         } else {
        //             // Handle non-200 status code
        //             console.error("Failed to fetch user information:", response);
        //         }
        //     } catch (error) {
        //         this.lblProgress = '';
        //         this.Error = true;
        //         this.Message = error.response.data.title;
        //         console.error("Error fetching user information:", error);
        //         // Handle the error here
        //     }
        // },
        async GetAnswerAI() {
            try {
                this.lblProgress = 'Processing';
                const response = await this.$API.get(this.$AskAI + "?statement=" + this.$route.query.statement, {
                    withCredentials: true,
                });

                if (response.status === 200) {
                    this.lblProgress = '';
                    this.result = response.data;

                } else {
                    this.lblProgress = '';
                    this.Error = true;
                    this.Message = error.response ? error.response.data.title : 'Unknown error';
                    console.error("Error fetching data:", error);
                }
            } catch (error) {
                this.lblProgress = '';
                this.Error = true;
                this.Message = error.response ? error.response.data.title : 'Unknown error';
                console.error("Error fetching data:", error);
            }
        },

        async SubmitAsk() {
            try {
                this.showAnswer = true;
                this.lblProgressAns = 'Processing';
                const response = await this.$API.get(this.$AskAI + "?statement=" + this.askStatement, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.lblProgress = '';
                    this.answerAsk = response.data;
                    this.lblProgressAns = '';

                } else {
                    this.lblProgress = '';
                    this.Error = true;
                    this.Message = error.response ? error.response.data.title : 'Unknown error';
                    console.error("Error fetching data:", error);
                }
            } catch (error) {
                this.lblProgress = '';
                this.Error = true;
                this.Message = error.response ? error.response.data.title : 'Unknown error';
                console.error("Error fetching data:", error);
                // Handle the error here
            }
        },
    }

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
div {
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
}

/* Hide scrollbar for WebKit browsers */
div::-webkit-scrollbar {
    display: none;
}

</style>